import { render } from "./uncompleteList.vue?vue&type=template&id=54c55d53&scoped=true"
import script from "./uncompleteList.vue?vue&type=script&lang=js"
export * from "./uncompleteList.vue?vue&type=script&lang=js"

import "./uncompleteList.vue?vue&type=style&index=0&id=54c55d53&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c55d53"]])

export default __exports__